import React, { useEffect, useState, useRef } from 'react'
import { Miniapptopbar } from '../HomeUser/components';
import { Search } from '../components/Header/components'
import { Retrieve_personal_info, getS3fullpath_withbucketname, iconwrapper } from '../../../config/commonfunctions';
import { HOME_COLLECTION_VENDORTYPE_WEDDING, READABLE_VENDORTYPE_MAP, VT_QUIZ_MAP, ABBREV_PRESENCELOC_MAP, TIER_DIAMOND_POSITION, ABBREVCITY_CURRENCY_MAP, SEARCH_FILTER_WEDDING, ABBREVCITY_ALLOW_ARR } from '../../../config/constants';
import { vendors_contentsizelink_wedding_map, VENDORCARDDATA, USER_CHANGE_LOC, USER_UPDATER_FILTER } from '../../../config/api';
import { Loading, Portalmodal, Processmoney, ScreenHeight, ScreenWidth, refresh } from '../../../components';
import { VendorsFilterAndSortModalContent, Quiz, Locationnotsupport } from '../components';
import { Heart } from '../../../async_components';
import { Checkdevicedetail } from '../../../components/Checkdevicedetail';
import { Link } from 'react-router-dom';
import { FILTERTHIN_ICON, THICKHEART_ICON, LOCATION_ICON, SORTNONFILL_ICON } from '../../../config/svgicons';
import axios from 'axios'
import './WeddingVendors.css'

const filter_portalmidcss_web = {
    width: 600,
    height: 660,
    top: 'calc( 50% - 330px )',
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none',
}

const filter_portalmidcss_mobile = {
    width: '100%',
    height: '100%',
    top: 0,
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none'
}

const filter_portalmidcsswtlarger_mobile = {
    width: '100%',
    height: '100%',
    top: 0,
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none',
    overflowX: 'scroll'
}

const getImgSrc = (vendor) => {
    const { profileimg_id = [] } = vendor

    if (profileimg_id.length > 0) {
        return getS3fullpath_withbucketname('VENDOR_PROFILE_IMG', profileimg_id[0].link)
    }
    else if ('link' in profileimg_id) {
        return getS3fullpath_withbucketname('VENDOR_PROFILE_IMG', profileimg_id.link)
    }
}

const VendorCard = ({ vendor, selectedvt, favouritebool, updateHeart, abbrev_userlocation }) => {
    const viewlookup = () => document.getElementById(vendor.username).click()

    return (
        <div className="vendor-card" key={vendor.key} >
            <Link id={vendor.username} style={{ width: 0, height: 0, visibility: 'hidden' }} to={'/vendorlookup/' + vendor.username} target="_blank" />

            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', placeContent: 'flex-end', height: 40, position: 'relative' }}>
                {vendor.tier === 0
                    ? <div className='VCARD_DIAMONDROOT' />
                    : <div className={`VCARD_DIAMONDROOT VCARD_DIAMONDROOT_${vendor.tier}`} style={{ position: 'absolute', top: 35 }}>
                        <div
                            className='VCARD_DIAMONDCONTENT'
                            style={{
                                backgroundImage: `url('https://asset.weavebliss.com/assets/sprites/diamonds.png')`,
                                backgroundPositionY: TIER_DIAMOND_POSITION[vendor.tier].y + 'px',
                            }}
                        />
                    </div>}
                <div style={{ width: '100%', height: 40, padding: '0px 5px', display: 'flex', placeContent: 'flex-end', alignItems: 'center', position: 'relative' }}>
                    <Heart
                        vendortypeinterface_id={vendor.vendortypeinterface_id}
                        vendortype={vendor.vendortype}
                        secondaryvendortype={vendor.secondaryvendortype}
                        vendortype_id={vendor.vendortype_id}
                        userlike={favouritebool}
                        updateHeart={updateHeart}
                        parent={'Vendorcard'}
                    />
                </div>
            </div>

            <div onClick={viewlookup} style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
                <img className="vendor-cardimg" src={getImgSrc(vendor)} alt={vendor.displayname} />

                <div className='vendor-cardinfo'>
                    <div className='vendor-cardinfo-name' style={{ overflow: 'hidden' }}>{vendor.displayname}</div>
                    <div className='vendor-cardinfo-vtroot'>
                        {selectedvt === 'All'
                            ? <>
                                <div className='vendor-cardinfo-vt'>{READABLE_VENDORTYPE_MAP[vendor.vendortype]}</div>
                                <div className='vendor-cardinfo-vt'>{READABLE_VENDORTYPE_MAP[vendor.secondaryvendortype]}</div>
                            </>
                            : <>
                                {vendor.vendortype === selectedvt ? <div className='vendor-cardinfo-vt'>{READABLE_VENDORTYPE_MAP[vendor.vendortype]}</div> : null}
                                {vendor.secondaryvendortype === selectedvt ? <div className='vendor-cardinfo-vt'>{READABLE_VENDORTYPE_MAP[vendor.secondaryvendortype]}</div> : null}
                            </>}
                    </div>
                </div>

                {selectedvt !== 'All'
                    ? <div className='vendor-cardpriceroot'>
                        {selectedvt === vendor.vendortype && vendor[abbrev_userlocation + 'minprice'] > 0
                            ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ color: 'var(--mainpink)', paddingRight: 5 }}>{`Starts At`}</div>
                                <div>{`$${Processmoney(vendor[abbrev_userlocation + 'minprice'])} ${ABBREVCITY_CURRENCY_MAP[abbrev_userlocation]}`}</div>
                            </div>
                            : ''}
                        {selectedvt === vendor.secondaryvendortype && vendor[abbrev_userlocation + 'minprice_svt'] > 0
                            ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ color: 'var(--mainpink)', paddingRight: 5 }}>{`Starts At`}</div>
                                <div>{`$${Processmoney(vendor[abbrev_userlocation + 'minprice_svt'])} ${ABBREVCITY_CURRENCY_MAP[abbrev_userlocation]}`}</div>
                            </div>
                            : ''}
                    </div>
                    : <div className='vendor-cardpriceroot' />}

                <div className='vendor-cardsephorizontal' />
                <div className="vendor-cardstats">
                    <div className='vendor-cardstatscol'>
                        <div className='vendor-cardstatslabel'>Review</div>
                        <div className="vendor-cardstatsreview">{vendor.review_num}</div>
                    </div>
                    <div className='vendor-cardsephorizontal' />
                    <div className='vendor-cardstatsrow'>
                        <div className='vendor-cardstatscol'>
                            <div className='vendor-cardstatslabel'>{`Project(s)`}</div>
                            <div className="vendor-cardstatsproject">{vendor.project_num}</div>
                        </div>
                        <div className='vendor-cardsepvertical' />
                        <div className='vendor-cardstatscol'>
                            <div className='vendor-cardstatslabel'>{`Pricelist(s)`}</div>
                            <div className="vendor-cardstatspricelist">{vendor.pricelist_num}</div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}

const VendorCardMobile = ({ vendor, selectedvt, favouritebool, updateHeart, abbrev_userlocation }) => {
    return (
        <div className="vendor-mobilecard">

            <div className='vendor-mobilerow'>
                <div className='vendor-mobilecol'>
                    <div className='vendor-mobilename'>{vendor.displayname}</div>
                    {selectedvt !== 'All'
                        ? <>
                            <div className='vendor-mobilevendortype'>{READABLE_VENDORTYPE_MAP[vendor.vendortype]}</div>
                            <div className='vendor-mobilesecondaryvendortype'>{READABLE_VENDORTYPE_MAP[vendor.secondaryvendortype]}</div>
                        </>
                        : <>
                            <div className='vendor-mobilevendortype'>{READABLE_VENDORTYPE_MAP[vendor.vendortype]}</div>
                            <div className='vendor-mobilesecondaryvendortype'>{READABLE_VENDORTYPE_MAP[vendor.secondaryvendortype]}</div>
                        </>
                    }

                </div>
                <div className='vendor-mobileheart'>
                    <Heart
                        vendortypeinterface_id={vendor.vendortypeinterface_id}
                        vendortype={vendor.vendortype}
                        secondaryvendortype={vendor.secondaryvendortype}
                        vendortype_id={vendor.vendortype_id}
                        userlike={favouritebool}
                        updateHeart={updateHeart}
                        parent={'Vendorcard'}
                    />
                </div>
            </div>

            <div className='vendor-mobilerow'>

                <img className="vendor-mobileimg" src={getImgSrc(vendor)} alt={vendor.displayname} />

                <div className="vendor-mobilestats">
                    <div className="vendor-mobilestatstop">
                        <div className='vendor-mobilelabel'>Review</div>
                        <div className='vendor-mobilevalue'>{vendor.review_num}</div>
                    </div>
                    <div className='vendor-cardsephorizontal' style={{ margin: '5px 20px' }} />
                    <div className="vendor-mobilestatsbtm">
                        <div className="vendor-mobilestatscol">
                            <div className='vendor-mobilelabel'>Pricelist</div>
                            <div className='vendor-mobilevalue'>{vendor.pricelist_num}</div>
                        </div>
                        <div className='vendor-cardsepvertical' style={{ margin: '0px 5px' }} />
                        <div className="vendor-mobilestatscol">
                            <div className='vendor-mobilelabel'>Project</div>
                            <div className='vendor-mobilevalue'>{vendor.project_num}</div>
                        </div>
                    </div>
                    <div className="vendor-mobilestatsbtm">
                        {selectedvt !== 'All'
                            ? <div className='vendor-mobilecardpriceroot'>
                                {selectedvt === vendor.vendortype && vendor[abbrev_userlocation + 'minprice'] > 0
                                    ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ color: 'var(--mainpink)', paddingRight: 5 }}>{`Starts At`}</div>
                                        <div>{`$${Processmoney(vendor[abbrev_userlocation + 'minprice'])} ${ABBREVCITY_CURRENCY_MAP[abbrev_userlocation]}`}</div>
                                    </div>
                                    : ''}
                                {selectedvt === vendor.secondaryvendortype && vendor[abbrev_userlocation + 'minprice_svt'] > 0
                                    ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ color: 'var(--mainpink)', paddingRight: 5 }}>{`Starts At`}</div>
                                        <div>{`$${Processmoney(vendor[abbrev_userlocation + 'minprice_svt'])} ${ABBREVCITY_CURRENCY_MAP[abbrev_userlocation]}`}</div>
                                    </div>
                                    : ''}
                            </div>
                            : <div className='vendor-mobilecardpriceroot' />}
                    </div>
                </div>

            </div>


        </div>
    );
};

const VendorCardSmallTablet = ({ vendor, selectedvt, favouritebool, updateHeart, abbrev_userlocation }) => {
    return (
        <div className="vendor-mobilecard" style={{ padding: '10px 10px 10px 20px' }}>

            <div className='vendor-mobilerow'>
                <div className='vendor-mobilecol'>
                    <div className='vendor-mobilename'>{vendor.displayname}</div>
                    {selectedvt !== 'All'
                        ? <>
                            <div className='vendor-mobilevendortype'>{READABLE_VENDORTYPE_MAP[vendor.vendortype]}</div>
                            <div className='vendor-mobilesecondaryvendortype'>{READABLE_VENDORTYPE_MAP[vendor.secondaryvendortype]}</div>
                        </>
                        : <>
                            <div className='vendor-mobilevendortype'>{READABLE_VENDORTYPE_MAP[vendor.vendortype]}</div>
                            <div className='vendor-mobilesecondaryvendortype'>{READABLE_VENDORTYPE_MAP[vendor.secondaryvendortype]}</div>
                        </>
                    }

                </div>
                <div className='vendor-mobileheart'>
                    <Heart
                        vendortypeinterface_id={vendor.vendortypeinterface_id}
                        vendortype={vendor.vendortype}
                        secondaryvendortype={vendor.secondaryvendortype}
                        vendortype_id={vendor.vendortype_id}
                        userlike={favouritebool}
                        updateHeart={updateHeart}
                        parent={'Vendorcard'}
                    />
                </div>
            </div>

            <div className='vendor-mobilerow'>

                <img className="vendor-mobileimg" src={getImgSrc(vendor)} alt={vendor.displayname} />

                <div style={{ width: '100%', display: 'flex', placeContent: 'center' }}>
                    <div className="vendor-mobilestats" style={{ width: '85%' }}>
                        <div className="vendor-mobilestatstop">
                            <div className='vendor-mobilelabel'>Review</div>
                            <div className='vendor-mobilevalue'>{vendor.review_num}</div>
                        </div>
                        <div className='vendor-cardsephorizontal' style={{ margin: '5px 20px' }} />
                        <div className="vendor-mobilestatsbtm">
                            <div className="vendor-mobilestatscol">
                                <div className='vendor-mobilelabel'>Pricelist</div>
                                <div className='vendor-mobilevalue'>{vendor.pricelist_num}</div>
                            </div>
                            <div className='vendor-cardsepvertical' style={{ margin: '0px 5px' }} />
                            <div className="vendor-mobilestatscol">
                                <div className='vendor-mobilelabel'>Project</div>
                                <div className='vendor-mobilevalue'>{vendor.project_num}</div>
                            </div>
                        </div>
                        <div className="vendor-mobilestatsbtm">
                            {selectedvt !== 'All'
                                ? <div className='vendor-mobilecardpriceroot'>
                                    {selectedvt === vendor.vendortype && vendor[abbrev_userlocation + 'minprice'] > 0
                                        ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ color: 'var(--mainpink)', paddingRight: 5 }}>{`Starts At`}</div>
                                            <div>{`$${Processmoney(vendor[abbrev_userlocation + 'minprice'])} ${ABBREVCITY_CURRENCY_MAP[abbrev_userlocation]}`}</div>
                                        </div>
                                        : ''}
                                    {selectedvt === vendor.secondaryvendortype && vendor[abbrev_userlocation + 'minprice_svt'] > 0
                                        ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ color: 'var(--mainpink)', paddingRight: 5 }}>{`Starts At`}</div>
                                            <div>{`$${Processmoney(vendor[abbrev_userlocation + 'minprice_svt'])} ${ABBREVCITY_CURRENCY_MAP[abbrev_userlocation]}`}</div>
                                        </div>
                                        : ''}
                                </div>
                                : <div className='vendor-mobilecardpriceroot' />}
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};


const s_ = { width: 30, height: 40, verticalAlign: 'middle', fill: 'currentColor', overflow: 'hidden' }
const vb_ = "0 0 1024 1024"
const v_ = "1.1"
const x_ = "http://www.w3.org/2000/svg"

const FLOATING_CLOSEBTN_STYLES = {
    left: -26,
    top: -26,
    color: '#eb5d7b'
}

function WeddingVendors(props) {

    // for background only
    useEffect(() => {
        let previousbgcolor = ""
        let previousBgimage = ""

        document.body.style.backgroundColor = 'var(--bodypink)'
        document.body.style.backgroundImage = 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)'
        return () => {
            document.body.style.backgroundColor = previousbgcolor || '';
            document.body.style.backgroundImage = previousBgimage || '';
        };
    }, [])

    const device = Checkdevicedetail()
    const screen_width = ScreenWidth()
    const screen_height = ScreenHeight()
    const { token } = Retrieve_personal_info()

    const [loading, setLoading] = useState(true)
    const [selectedvt, setSelectedvt] = useState('')
    const [selectedwedorevent, setSelecteedwedorevent] = useState('')
    const [selecteditem, setSelecteditem] = useState(null)
    const [abbrev_locations, setAbbrev_locations] = useState([])
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [scrolltop, setScrolltop] = useState(-1)

    // from first api call
    const [abbrev_userlocation, setAbbrev_userlocaation] = useState('')
    const [loc, setLoc] = useState('')
    const [totalvendors, setTotalvendors] = useState(0)
    const [favourite, setFavourite] = useState([]) // vti_id only
    const [filtersetting_w, setFiltersetting_w] = useState({})
    const [batches, setBatches] = useState([])
    const [numbatch, setNumbatch] = useState(-1)
    const [totalfilternum, setTotalfilternum] = useState(0)
    const [totalsortnum, setTotalsortnum,] = useState(0)

    // from second and subsequent api call
    const [data, setData] = useState([])

    // portal
    const [showfilter, setShowfilter] = useState(false)
    const [showsort, setShowsort] = useState(false)
    const [showlocation, setShowlocation] = useState(false)
    const [showquiz, setShowquiz] = useState(false)

    // refs for scroll handler to avoid stale closures
    const isFetchingBatchRef = useRef(false)
    const numbatchRef = useRef(-1)
    const batchesRef = useRef([])
    const scrollTimerRef = useRef(null)


    const fetchItems = (selectedvt) => {

        const obtainbatches = (arr, max) => {
            let batches = [];
            for (let i = 0; i < arr.length; i += max) {
                batches.push(arr.slice(i, i + max));
            }
            return batches.slice()
        }
        try {

            axios({
                method: 'POST',
                url: vendors_contentsizelink_wedding_map[selectedvt],
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                data: { "selectedvt": selectedvt }
            })
                .then((result) => {
                    const { data, status } = result
                    const { error } = data
                    if (status === 200 && error === false) {
                        const {
                            totalcard_count, rendercard_count,
                            items, favourite, filtersetting_w,
                            abbrev_userlocation,
                        } = data.data

                        if (selectedvt === 'All') {
                            // items : 
                            // _id: 1, // vendortypeinterface_id
                            // username: 1,
                            // vendortype: 1, vendortype_id: 1,
                            // secondaryvendortype: 1, secondaryvendortype_id: 1,
                            // review_num: 1, project_num: 1, pricelist_num: 1
                            let new_items = JSON.parse(JSON.stringify(items))
                            for (let i = 0; i < items.length; i++) {
                                const { _id } = items[i]
                                new_items[i]['vendortypeinterface_id'] = _id
                            }
                            setAbbrev_userlocaation(abbrev_userlocation)
                            setLoc(ABBREV_PRESENCELOC_MAP[abbrev_userlocation])
                            setTotalvendors(totalcard_count)
                            setFiltersetting_w(filtersetting_w)
                            setBatches(obtainbatches(new_items, rendercard_count))
                            setFavourite(favourite.map((item, index) => { return item[0] }))
                            setNumbatch(0)
                            setLoading(false)
                        }
                        else {
                            // items : 
                            // vendortypeinterface_id: 1,
                            // username: 1,
                            // vendortype: 1,_id: 1, // vendortype id
                            // secondaryvendortype: 1,secondaryvendortype_id: 1,
                            // review_num: 1,project_num: 1,pricelist_num: 1
                            let new_items = JSON.parse(JSON.stringify(items))
                            for (let i = 0; i < items.length; i++) {
                                const { _id } = items[i]
                                new_items[i]['vendortype_id'] = _id
                            }
                            setAbbrev_userlocaation(abbrev_userlocation)
                            setLoc(ABBREV_PRESENCELOC_MAP[abbrev_userlocation])
                            setTotalvendors(totalcard_count)
                            setFiltersetting_w(filtersetting_w)
                            setBatches(obtainbatches(new_items, rendercard_count))
                            setNumbatch(0)
                            setLoading(false)
                        }

                    }
                })
                .catch(e => { })
        }
        catch (e) {
        }
    }

    // keep refs in sync with state
    useEffect(() => { numbatchRef.current = numbatch }, [numbatch])
    useEffect(() => { batchesRef.current = batches }, [batches])

    useEffect(() => {

        setLoading(true)

        const { match } = props

        const vt = match?.params?.vt.toLowerCase()
        const wedorevent = match?.params?.wedorevent.toLowerCase()

        let selectedvt = vt[0].toUpperCase() + vt.slice(1) || ''
        let selectedwedorevent = wedorevent[0].toUpperCase() + wedorevent.slice(1) || ''

        setSelectedvt(selectedvt)
        setSelecteedwedorevent(selectedwedorevent)
        setSelecteditem(HOME_COLLECTION_VENDORTYPE_WEDDING.find(({ value }) => value === selectedvt))

        if (vt.length > 0) {
            fetchItems(vt[0].toUpperCase() + vt.slice(1))
        }

        const handleScroll = () => {
            clearTimeout(scrollTimerRef.current)
            scrollTimerRef.current = setTimeout(() => {
                const nearBottom =
                    window.innerHeight + window.scrollY >= document.body.offsetHeight - 200

                if (nearBottom && !isFetchingBatchRef.current && numbatchRef.current < batchesRef.current.length - 1) {
                    isFetchingBatchRef.current = true
                    setNumbatch(prev => prev + 1)
                }
            }, 300) // waits 300ms after user stops scrolling
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    useEffect(() => {
        if (numbatch > -1 && batches.length > 0) {
            const vti_ids = batches[numbatch].map(({ vendortypeinterface_id }) => vendortypeinterface_id);

            try {
                const { token } = Retrieve_personal_info()
                axios({
                    method: 'POST',
                    url: VENDORCARDDATA,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                    data: { "vti_ids": vti_ids, "vt": selectedvt }
                })
                    .then((item) => {
                        const { message, result } = item.data
                        if (message === 'SUCCESS') {

                            // result original sequence is not preserve, need to sort them again
                            let sortedResult = result.sort((a, b) => vti_ids.indexOf(a._id) - vti_ids.indexOf(b._id))
                            for (let i = 0; i < sortedResult.length; i++) {
                                sortedResult[i]['vendortypeinterface_id'] = sortedResult[i]['_id']
                            }
                            setData(prev => [...prev, ...sortedResult])  // ✅ functional update, no stale closure
                            isFetchingBatchRef.current = false      // ✅ unblock next scroll trigger
                        }
                    })
                    .catch(e => {
                        isFetchingBatchRef.current = false          // ✅ also unblock on error
                    })
            }
            catch (e) {
                isFetchingBatchRef.current = false
            }
        }
    }, [numbatch])

    useEffect(() => {
        // will only appear in Home, Wedding and Event page
        if (abbrev_userlocation) {
            var NEW_ABBREV_PRESENCE_LOCATION = [...Object.keys(ABBREVCITY_CURRENCY_MAP)]
            NEW_ABBREV_PRESENCE_LOCATION.splice(NEW_ABBREV_PRESENCE_LOCATION.indexOf(abbrev_userlocation), 1)
            NEW_ABBREV_PRESENCE_LOCATION.unshift(abbrev_userlocation)
            setAbbrev_locations(NEW_ABBREV_PRESENCE_LOCATION)
        }
    }, [abbrev_userlocation])

    const changeVt = (e) => {
        const { value } = e.currentTarget
        if (value) {

            const selectedvt = value[0].toUpperCase() + value.slice(1) || ''

            setSelectedvt(selectedvt)
            setSelecteditem(HOME_COLLECTION_VENDORTYPE_WEDDING.find(({ value }) => value === selectedvt))

            window.history.replaceState(null, '', `/vendor/${selectedwedorevent.toLocaleLowerCase()}/${value.toLocaleLowerCase()}`)
            setDropdownOpen(false)

            setLoading(true)
            setData([])
            setBatches([])
            setNumbatch(-1)
            fetchItems(value, selectedwedorevent)
        }
    }

    useEffect(() => {

        let total_sort_num = 0
        let total_filter_num = 0

        try {

            let sortarr = []
            // obtain all sort items in arr
            for (let i = 0; i < SEARCH_FILTER_WEDDING[selectedvt]['Sort'].length; i++) {
                const { header } = SEARCH_FILTER_WEDDING[selectedvt]['Sort'][i]
                console.log('header', header)
                sortarr.push(header)
            }

            // for (let i = 0; i < sortarr.length; i++) {
            //     if (filtersetting_w['Wedding' + selectedvt].indexOf(sortarr[i]) > -1) {
            //         total_sort_num += 1
            //     }
            // }

            for (let i = 0; i < filtersetting_w['Wedding' + selectedvt].length; i++) {
                if (sortarr.indexOf(filtersetting_w['Wedding' + selectedvt][i]) > -1) {
                    total_sort_num += 1
                }
            }


            total_filter_num = filtersetting_w['Wedding' + selectedvt].length - total_sort_num
            setTotalfilternum(total_filter_num)
            setTotalsortnum(total_sort_num)

        }
        catch (e) { }

    }, [filtersetting_w])

    const MOBILE_VT = (
        <div style={{ padding: '0px 10px 24px 10px', width: '100%', boxSizing: 'border-box', fontFamily: 'Lato' }}>

            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 5 }}>
                <button className='Vendor_mobilelocation' onClick={() => setShowlocation(true)}>{abbrev_userlocation.toUpperCase()}</button>
                <div className="Vendor_dropdownwrap">
                    <button
                        className={`Vendor_dropdowntrigger ${dropdownOpen ? 'Vendor_dropdowntrigger--open' : ''}`}
                        onClick={() => setDropdownOpen(o => !o)}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            {selecteditem?.icon && (
                                <div className="Vendor_dropdown_iconwrap">
                                    {iconwrapper(selecteditem.icon, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center', placeSelf: 'center' })}
                                </div>
                            )}
                            <span>{selectedvt ? READABLE_VENDORTYPE_MAP[selectedvt] : 'All Vendors'}</span>
                        </div>
                        <svg className={`Vendor_chevron ${dropdownOpen ? 'Vendor_chevron--open' : ''}`} width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4 6l4 4 4-4" stroke="var(--maindark)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    {dropdownOpen && (
                        <div className="Vendor_dropdownlist">
                            {HOME_COLLECTION_VENDORTYPE_WEDDING.map(({ value, icon }, index) => {
                                const item = READABLE_VENDORTYPE_MAP[value]
                                const isSelected = selectedvt === value || (!selectedvt && value === 'All')
                                return (
                                    <button
                                        key={index + 'dd'}
                                        className={`Vendor_dropdownitem ${isSelected ? 'Vendor_dropdownitem--selected' : ''}`}
                                        value={value}
                                        onClick={changeVt}
                                    >
                                        {value !== 'All'
                                            ? <div className="Vendor_dropdown_iconwrap">
                                                {iconwrapper(icon, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center', placeSelf: 'center' })}
                                            </div>
                                            : <div className="Vendor_dropdown_iconwrap" style={{ backgroundColor: 'var(--bodypink)' }}>
                                            </div>
                                        }
                                        <span>{READABLE_VENDORTYPE_MAP[value]}</span>
                                        {props.usertype === 'Wedding' && Object.keys(VT_QUIZ_MAP).includes(item)
                                            ? <div className='Vendor_quizdot' />
                                            : null}
                                        {isSelected && (
                                            <svg style={{ marginLeft: 'auto' }} width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M3 8l4 4 6-6" stroke="#e8799a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        )}
                                    </button>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>

            <div className='Vendor_mobilefiltersortvendorfoundroot'>
                <div className='Vendor_mobilefiltersortroot'>
                    <button
                        className='Vendor_mobileheartbtn'
                        onClick={() => {
                            window.open('/favourite/vendor', '_blank');  // Open link in a new tab
                        }}
                    >
                        {iconwrapper(THICKHEART_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                    </button>
                    {selectedvt !== 'All'
                        ? <button
                            className='Vendor_mobilefilter'
                            onClick={() => {
                                document.body.style.overflow = 'hidden'
                                setShowfilter(true)
                            }}
                        >
                            {iconwrapper(FILTERTHIN_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                            {totalfilternum === 0 ? null : <div className='Vendor_filternum'>{`${totalfilternum}`} </div>}
                        </button>
                        : null}
                    <button
                        className='Vendor_mobilefilter'
                        onClick={() => {
                            setShowsort(true)
                            document.body.style.overflow = 'hidden'
                        }}>
                        {iconwrapper(SORTNONFILL_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                        {totalsortnum === 0 ? null : <div className='Vendor_filternum'>{`${totalsortnum}`} </div>}
                    </button>
                    {props.usertype === 'Wedding' && Object.keys(VT_QUIZ_MAP).includes(selectedvt)
                        ? <button
                            className='Vendor_mobilefilter'
                            onClick={() => {
                                setShowquiz(true)
                                document.body.style.overflow = 'hidden'
                            }}>
                            Quiz
                        </button>
                        : null}
                </div>
                <div className='Vendor_mobilevendorfound'>{`${totalvendors} Vendors Found`}</div>
            </div>
        </div>
    )

    const DESKTOP_VT = (
        <div style={{ padding: '0px 20px 24px 20px', width: '100%', boxSizing: 'border-box', fontFamily: 'Lato' }}>
            <div style={{ maxWidth: 1320, margin: '0 auto' }}>
                <div className="Vendor_itemroot">
                    <button
                        className='Vendor_filtersortbtnleft'
                        style={{ placeSelf: 'flex-start', display: 'flex', flexDirection: 'row', marginBottom: 5 }}
                        onClick={() => setShowlocation(true)}
                    >
                        {iconwrapper(LOCATION_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                        {loc}
                    </button>
                    <div className="Vendor_itemsubroot">

                        {HOME_COLLECTION_VENDORTYPE_WEDDING.map(({ value, icon, }, index) => {
                            const item = READABLE_VENDORTYPE_MAP[value]
                            const isSelected = selectedvt === value || (!selectedvt && value === 'All')
                            return (
                                <button
                                    className={`Vendor_singleitemroot ${isSelected ? 'Vendor_singleitemroot--selected' : ''}`}
                                    value={value}
                                    onClick={changeVt}
                                    key={index + 'vt'}
                                >
                                    {value === 'All'
                                        ? <>
                                            <div className="Vendor_singleitemname" style={{ height: '100%', placeItems: 'center' }}>{`All\nVendors`}</div>
                                            {props.usertype === 'Wedding' && Object.keys(VT_QUIZ_MAP).includes(item)
                                                ? <div className='Vendor_quizdot' />
                                                : null}
                                        </>
                                        : <>
                                            <div className="Vendor_iconwrap">
                                                {iconwrapper(icon, { width: 25, height: 25 })}
                                            </div>
                                            <div className="Vendor_singleitemname">{READABLE_VENDORTYPE_MAP[value]}</div>
                                            {props.usertype === 'Wedding' && Object.keys(VT_QUIZ_MAP).includes(item)
                                                ? <div className='Vendor_quizdot' />
                                                : null}
                                        </>}
                                </button>
                            )
                        })}
                    </div>
                </div>
            </div>
            <div className='Vendor_filterroot' style={{ maxWidth: 1320, margin: '0 auto' }}>
                <div className='Vendor_filtersortrow' >
                    <div className='Vendor_filtersortroot'>

                        <button
                            className='Vendor_filtersortbtnleftheart'
                            onClick={() => { window.open('/favourite/vendor', '_blank'); }}
                        >
                            {iconwrapper(THICKHEART_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                        </button>

                        {selectedvt !== 'All'
                            ? <button
                                className='Vendor_filtersortbtnleft'
                                onClick={() => {
                                    document.body.style.overflow = 'hidden'
                                    setShowfilter(true)
                                }}
                            >
                                {iconwrapper(FILTERTHIN_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                                {totalfilternum === 0 ? null : <div className='Vendor_filternum'>{`${totalfilternum}`} </div>}
                            </button>
                            : null}


                        <button
                            className='Vendor_filtersortbtnleft'
                            onClick={() => {
                                document.body.style.overflow = 'hidden'
                                setShowsort(true)
                            }}
                        >
                            {iconwrapper(SORTNONFILL_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                            {totalsortnum === 0 ? null : <div className='Vendor_filternum'>{`${totalsortnum}`} </div>}
                        </button>

                        {props.usertype === 'Wedding' && Object.keys(VT_QUIZ_MAP).includes(selectedvt)
                            ? <button
                                className='Vendor_quizbtn'
                                onClick={() => {
                                    document.body.style.overflow = 'hidden'
                                    setShowquiz(true)
                                }}
                            >
                                Quiz</button>
                            : null}

                    </div>
                    <div className='Vendor_numlabel'>{`${totalvendors} Vendors Found`}</div>
                </div>
            </div>
        </div>
    )

    const MOBILE_CARDSDOM = (
        <div className="vendor-mobilecardsroot">
            {data.map((vendor, index) => (
                <VendorCardMobile
                    key={vendor.vendortypeinterface_id}
                    vendor={vendor}
                    selectedvt={selectedvt}
                    abbrev_userlocation={abbrev_userlocation}
                    favouritebool={favourite.includes(vendor.vendortypeinterface_id)}
                    updateHeart={(addorremove, id) => {
                        let curr_fav = favourite.slice()
                        if (addorremove) { // add
                            curr_fav.push(id)
                            setFavourite(curr_fav)
                        }
                        else { //remove
                            var index = favourite.indexOf(id)
                            curr_fav.splice(index, 1)
                            setFavourite(curr_fav)
                        }
                    }}
                />
            ))}
        </div>
    )

    const DESKTOP_CARDSDOM = (
        <div className="vendor-cardsroot">
            {data.map(vendor => <VendorCard
                key={vendor.vendortypeinterface_id}
                vendor={vendor}
                selectedvt={selectedvt}
                abbrev_userlocation={abbrev_userlocation}
                favouritebool={favourite.includes(vendor.vendortypeinterface_id)}
                updateHeart={(addorremove, id) => {
                    let curr_fav = favourite.slice()
                    if (addorremove) { // add
                        curr_fav.push(id)
                        setFavourite(curr_fav)
                    }
                    else { //remove
                        var index = favourite.indexOf(id)
                        curr_fav.splice(index, 1)
                        setFavourite(curr_fav)
                    }
                }}
            />

            )}
        </div>
    )

    const SMALLTABLET_CARDSDOM = (
        <div className="vendor-mobilecardsroot" style={{ padding: '0px 20px 24px 20px' }}>
            {data.map((vendor, index) => (
                <VendorCardSmallTablet
                    key={vendor.vendortypeinterface_id}
                    vendor={vendor}
                    selectedvt={selectedvt}
                    abbrev_userlocation={abbrev_userlocation}
                    favouritebool={favourite.includes(vendor.vendortypeinterface_id)}
                    updateHeart={(addorremove, id) => {
                        let curr_fav = favourite.slice()
                        if (addorremove) { // add
                            curr_fav.push(id)
                            setFavourite(curr_fav)
                        }
                        else { //remove
                            var index = favourite.indexOf(id)
                            curr_fav.splice(index, 1)
                            setFavourite(curr_fav)
                        }
                    }}
                />
            ))}
        </div>
    )

    const onApplyFilter = (filter_queries) => {
        console.log('filter_queries', filter_queries)
        try {
            let options = {
                method: 'POST',
                url: USER_UPDATER_FILTER,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                data: { filter_queries, selectedVendorType: selectedvt, selectedMainCategory: 'Wedding' }
            }
            axios(options)
                .then((result) => {
                    const { message } = result.data
                    if (message === 'SUCCESS') {
                        setData([])
                        setAbbrev_userlocaation('')
                        setLoc('')
                        setTotalvendors(0)
                        setFiltersetting_w({})
                        setBatches([])
                        setNumbatch(-1)
                        setLoading(true)
                        setShowfilter(false)
                        setShowsort(false)
                        fetchItems(selectedvt)
                        window.scroll(0, 0)
                        document.body.style.overflow = ''
                    }
                })
                .catch((e) => {
                    refresh()
                })
        }
        catch (e) {
            refresh()
        }

    }

    const FILTER_PORTAL = <Portalmodal
        portaltype={'commonportal'}
        open={showfilter}
        onClose={() => {
            document.getElementById('app-root').style.overflowY = ''
            if (device === 'MOBILE') {
                document.body.style.position = ''
                document.documentElement.scrollTop = scrolltop
                setScrolltop(-1)
            }
            document.body.style.overflow = ''
            setShowfilter(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={(device === 'WEB' || device === 'TABLET') ? filter_portalmidcss_web : screen_width > screen_height ? filter_portalmidcsswtlarger_mobile : filter_portalmidcss_mobile}
        closestyle={{ right: 0 }}
        floatingclosecolor='var(--maindark)'
        title={'Filter'}
    >
        <div className='Portalmodal_vtroot'>
            <VendorsFilterAndSortModalContent
                onApplyFilter={onApplyFilter}
                filtersetting={filtersetting_w}
                usertype={'Wedding'}
                sortorfilter={'FILTER'}
                selectedVendorType={selectedvt}
                availablefilters={SEARCH_FILTER_WEDDING}
            />
        </div>
    </Portalmodal>

    const SORT_PORTAL = <Portalmodal
        portaltype={'commonportal'}
        open={showsort}
        onClose={() => {
            document.getElementById('app-root').style.overflowY = ''
            if (device === 'MOBILE') {
                document.body.style.position = ''
                document.documentElement.scrollTop = scrolltop
                setScrolltop(-1)
            }
            document.body.style.overflow = ''
            setShowsort(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={(device === 'WEB' || device === 'TABLET') ? filter_portalmidcss_web : screen_width > screen_height ? filter_portalmidcsswtlarger_mobile : filter_portalmidcss_mobile}
        closestyle={{ right: 0 }}
        floatingclosecolor='var(--maindark)'
        title={'Sort'}
    >
        <div className='Portalmodal_vtroot'>
            <VendorsFilterAndSortModalContent
                onApplyFilter={onApplyFilter}
                filtersetting={filtersetting_w}
                usertype={'Wedding'}
                sortorfilter={'SORT'}
                selectedVendorType={selectedvt}
                availablefilters={SEARCH_FILTER_WEDDING}
            />
        </div>
    </Portalmodal>

    const LOCATION_PORTAL = <Portalmodal
        portaltype={'commonportal'}
        open={showlocation}
        onClose={() => {
            document.getElementById('app-root').style.overflowY = ''
            if (device === 'MOBILE') {
                document.body.style.position = ''
                document.documentElement.scrollTop = scrolltop
                setScrolltop(-1)
            }
            document.body.style.overflow = ''
            setShowlocation(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={{
            height: device === 'MOBILE' ? '100%' : 'max-content',
            width: device === 'MOBILE' ? '100%' : 450
        }}
        closestyle={{ right: 0 }}
        floatingclosecolor='var(--maindark)'
        title={'Location'}
    >
        <div className='Portalmodal_vtroot'>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', overflowY: 'auto', marginBottom: 10 }}>
                {abbrev_locations.map((val, i) => {
                    return <div
                        className={abbrev_userlocation === val ? 'Portalinnerelem_selected' : 'Portalinnerelem'}
                        style={{
                            borderRadius: i === 0 ? '10px 10px 0px 0px' : i === abbrev_locations.length - 1 ? '0px 0px 10px 10px' : '0px',
                            cursor: 'pointer'
                        }}
                        key={val}
                        onClick={() => {
                            try {
                                let options = {
                                    method: 'POST',
                                    url: USER_CHANGE_LOC,
                                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                                    data: { new_loc: ABBREV_PRESENCELOC_MAP[val.toLowerCase()] }
                                }
                                axios(options).then(() => {
                                    refresh()
                                }).catch((e) => {
                                    refresh()
                                })
                            }
                            catch (e) {
                                refresh()
                            }
                        }}
                    >
                        <div className="locationselector_val">{val.toUpperCase()}</div>
                        <div className="locationselector_locitem">{ABBREV_PRESENCELOC_MAP[val]}</div>
                    </div>
                })}
            </div>
        </div>
    </Portalmodal>

    const QUIZ_DOM = showquiz
        ? <div style={{
            position: 'fixed', height: screen_height, display: 'flex', flexDirection: 'column', padding: 10,
            width: '100%', top: 0, backgroundColor: "white", zIndex: 999, overflow: 'auto',
            backgroundImage: 'radial-gradient(circle, #cccccc 1px, transparent 1px)',
            backgroundSize: '20px 20px',
            backgroundColor: '#ffffff'
        }}>
            <button
                className='Portalmodal_close'
                style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    position: 'absolute',
                    padding: 0,
                    cursor: 'pointer',
                    zIndex: 1,
                    color: '#707070',
                    height: 60,
                    margin: '0px 10px', FLOATING_CLOSEBTN_STYLES
                }}
                onClick={() => {
                    document.body.style.overflow = 'hidden'
                    setShowquiz(false)
                }
                }
            >
                <svg className="icon" style={{ ...s_, width: 32, height: 32, borderRadius: '100%', backgroundColor: 'white' }} viewBox={vb_} version={v_} xmlns={x_}><path style={{ fill: 'var(--maindark)', }} d="M442.24 517.504l-114.88 115.2a48 48 0 1 0 67.968 67.776l114.688-115.008L624.768 700.48a48 48 0 0 0 67.968-67.84l-114.88-115.136 114.88-115.072a48 48 0 1 0-67.968-67.84L510.016 449.6 395.328 334.592a48 48 0 0 0-67.968 67.84l114.88 115.072zM512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z" fill="#666666" p-id="10405"></path></svg>
            </button>
            <Quiz
                {...props}
                cat={'Wedding'}
                vt={selectedvt}
                token={token}
                close={() => {
                    document.body.style.overflow = ''
                    setShowquiz(false)
                }}
            />
        </div>
        : null

    const CARDS_MAIN = <div style={{ maxWidth: '100%', display: 'flex', placeItems: 'center', placeContent: 'center' }}>
        <div style={{ width: device === 'WEB' ? 1320 : '100%', display: 'flex', placeItems: 'center' }}>
            {{
                'WEB': DESKTOP_CARDSDOM,
                'TABLET': DESKTOP_CARDSDOM,
                'SMALLTABLET': SMALLTABLET_CARDSDOM,
                'MOBILE': MOBILE_CARDSDOM
            }[device]}
        </div>
    </div>

    return !loading
        ? <div className='WeddingVendors_root'>
            <Miniapptopbar {...props} currentpage={'VENDOR'} abbrev_userlocation={abbrev_userlocation}/>
            <Search
                {...props}
                wrapperstyle={{ width: '100%', padding: '24px 10px', }}
            // wrapperstyle={{backgroundColor: '#fff1f4',width:'100%', padding:'24px 10px', backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)'}}
            />
            {ABBREVCITY_ALLOW_ARR.includes(abbrev_userlocation)
                ? <>
                    {device === 'MOBILE' ? MOBILE_VT : DESKTOP_VT}
                    {CARDS_MAIN}
                    {FILTER_PORTAL}
                    {SORT_PORTAL}
                    {LOCATION_PORTAL}
                    {QUIZ_DOM}
                </>
                :<Locationnotsupport from='WEDDINGVENDORS' />}


        </div>
        : <Loading />
}

export default WeddingVendors



